import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/service/auth';
import {BasicService} from 'src/service/basic.service';
declare var require: any;
const Swal = require('sweetalert2');
@Component({
  selector: 'app-sign-on',
  templateUrl: './sign-on.component.html',
  styleUrls: ['./sign-on.component.scss']
})
export class SignOnComponent implements OnInit {
  token=''
  constructor(private authService: AuthService,private activatedRoute:ActivatedRoute,private basicService:BasicService,private router: Router) { 
    activatedRoute.params.subscribe(params=>{
      this.token=params['token'];
      let data={
        token:this.token
      }
      this.basicService.showprogress=true;
      this.authService.loginWithLoginToken(data).toPromise().then((response: any) => {
        this.basicService.showprogress=false;
        if(response.status === "success"){
          this.basicService.user_data=response.user_data
          this.basicService.user_data.password=this.token
          this.basicService.setItem("user_data",this.basicService.user_data);
          this.router.navigate(['/customer/dashboard']);
        } else {
          Swal.fire({
            icon: 'Error',
            title: 'Error',
            text: response.message,
            confirmButtonColor: '##0d6efd',
            showCancelButton: false,
            allowOutsideClick: true,
            confirmButtonText: 'Ok'
          }).then((result:any) => {
          });
        }
      }); 
    });
  }

  ngOnInit(): void {
  }

}
